<template>
  <div v-if="filters && filters.length > 0" class="is-flex">
    <div
      :key="filter.designator"
      v-for="filter in filters"
    >
      <p style="margin-bottom: 3px;">{{ filter.designator }}</p>
      <select
        @change="updateSingleFilter(filter, $event.target.value)"
      >
        <option value="remove_filter">NOT SELECTED</option>
        <option
          :selected="filters_helper.isFilterOptionSelected(filter, option)"
          v-for="option in filter.options"
          :key="option.value"
          :value="option.value"
          >{{ option.text }}</option
        >
      </select>
    </div>
  </div>
</template>
<script>
import FiltersHelper from '@/custom/classes/filters_helper.js'
export default {
  name: 'single-filters',
  props: ['filters'],
  data () {
    return {
      filters_helper: new FiltersHelper()
    }
  },
  methods: {
    updateSingleFilter (filter, value) {
      let query = { ...this.$route.query }
      query[filter.designator] = value == 'remove_filter' ? undefined : value
      this.$router.push({ path: this.$route.path, query: query })
    }
  }
}
</script>
<style scoped>
  select {
    margin-right: 10px;
  }
</style>
